import React from 'react';
import { ThemeProvider } from '../contexts/ThemeContext';
import { MusicProvider } from '../contexts/MusicContext';

export function AppProviders({ children }) {
  return (
    <ThemeProvider>
      <MusicProvider>{children}</MusicProvider>
    </ThemeProvider>
  );
}
